export default "__VITE_ASSET__Q3w1SXW3__"